import { Gender } from "@/components/graphql/types/globalTypes";

export interface PageViewInterface {
  page: string;
  type?: string;
  is_loggedin: boolean;
  momverse_stage: string;
  platform?: string;
  age?: string | number;
  nav_src?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  firstname?: string;
  category_name?: string;
  city?: string;
  page_name?: string;
  lob?: string;
}

export interface AssetClickedInterface {
  asset_name: string;
  asset_display_text: string;
  momverse_stage: string;
  asset_position: number;
  screen_name?: string;
  nav_src?: string;
  screen_identifier?: string;
  asset_element_position?: number;
}

export interface ButtonClickedInterface {
  button_position?: number;
  button_name: string;
  is_loggedin: boolean;
  momverse_stage: string;
  screen_name?: string;
  screen_identifier?: string;
}

export interface PopupViewedInterface {
  momverse_stage: string;
  popup_name: string;
  popup_position: string;
  nav_src?: string;
}

export enum Actions {
  ADD = "add",
  EDIT = "edit",
  DELETE = "delete",
}
export interface DateAddedInterface {
  momverse_stage: string;
  is_loggedin: boolean;
  action: Actions;
  date_type: string;
  date?: string | number;
  average_cycle?: string;
}

export interface LoginDoneInterface {
  mobile: string;
  platform: string;
  is_new_user: boolean;
  lob?: string;
  gender: Gender;
  nav_src?: string;
  is_corporate?: boolean;
}
